import React, { useState } from "react";
import { Facebook, Twitter, Send, MessageCircle, Link2, Check } from "lucide-react";

export default function ShareButtons({ url, title }) {
  const [copied, setCopied] = useState(false);
  const fullUrl = typeof window !== "undefined" ? window.location.href : url;
  const enc = encodeURIComponent;
  const items = [
    { id: "facebook", label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(fullUrl)}` },
    { id: "twitter", label: "X / Twitter", icon: Twitter, href: `https://twitter.com/intent/tweet?url=${enc(fullUrl)}&text=${enc(title || "")}` },
    { id: "telegram", label: "Telegram", icon: Send, href: `https://t.me/share/url?url=${enc(fullUrl)}&text=${enc(title || "")}` },
    { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${enc((title ? title + " — " : "") + fullUrl)}` },
  ];

  function copy() {
    navigator.clipboard?.writeText(fullUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <div className="border-t border-b border-slate-200 py-4 my-8 flex items-center gap-3 flex-wrap" data-testid="share-buttons">
      <span className="text-xs uppercase tracking-[0.25em] font-semibold text-slate-500">Share</span>
      {items.map((it) => (
        <a
          key={it.id}
          href={it.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`share-${it.id}`}
          className="w-10 h-10 border border-slate-300 flex items-center justify-center text-slate-700 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition"
          aria-label={it.label}
        >
          <it.icon className="w-4 h-4" strokeWidth={1.7} />
        </a>
      ))}
      <button
        onClick={copy}
        data-testid="share-copy"
        className="w-10 h-10 border border-slate-300 flex items-center justify-center text-slate-700 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition"
        aria-label="Copy link"
      >
        {copied ? <Check className="w-4 h-4 text-green-600" /> : <Link2 className="w-4 h-4" strokeWidth={1.7} />}
      </button>
    </div>
  );
}
